import { createContext } from 'react'
import { DATASET_QUERY_LIMIT } from './constants'
import { DatasetQueryContextValue } from './types'

const emptyFn = () => {
  // do nothing
}

export const DatasetQueryContext = createContext<DatasetQueryContextValue>({
  commitRef: '',
  datasetLoading: true,
  datasetRowCount: 0,
  limit: DATASET_QUERY_LIMIT,
  offset: 0,
  queryOptionsByFieldId: {},
  queryRowCountIsLoading: true,
  queryRowCount: 0,
  refetchDatasetTrigger: 0,
  showHiddenFields: false,
  showHiddenColumns: false,
  submissionPartials: {},
  submissionPartialsLoading: false,
  updatingFilters: false,
  addFilter: emptyFn,
  appendFilter: emptyFn,
  clearQueryOptionsByFieldId: emptyFn,
  getAllDatasetData: () => Promise.resolve(null),
  getDatasetId: () => null,
  getFiltersByFieldId: () => [],
  getQueryOptionsByFieldId: () => ({}),
  getSearchTermByFieldId: () => '',
  getSortOrderByFieldId: () => null,
  hasFilterWithOperator: () => false,
  hasQueryOptions: () => false,
  makeQueryOptionsDto: () => ({}),
  refetchDataset: emptyFn,
  removeFilterByFieldId: emptyFn,
  setCommitRef: emptyFn,
  setDatasetLoading: emptyFn,
  setOffsetDebounced: emptyFn,
  setQueryOptionsByFieldId: emptyFn,
  updateFilterOperatorByFieldId: emptyFn,
  updateFilterValueByFieldId: emptyFn,
  updateFiltersByFieldId: emptyFn,
  updateQueryOptionsByFieldId: () => ({}),
  updateSortOrderByFieldId: emptyFn,
  updateShowHiddenFields: emptyFn,
  updateUrlParams: emptyFn,
})
